import { ALLOW_COURSE_CONTENT_DOWNLOAD } from '@constants/features'
import { isDownloadOnlyFileExt } from '@constants/mediaTypes'
import { IMedia } from '@dtos/Course'
import { useContentDownload } from '@hooks/useContentDownload'
import { useHasFeature } from '@hooks/useThemeParams'
import { useCallback, useMemo } from 'react'

// Tipos de mídia cobertos pela feature `allow_course_content_download`, mesma
// regra do tema antigo (Image/Document): são os conteúdos que a área de membros
// renderiza embutidos e que, sem esta feature, o aluno não consegue baixar.
const DOWNLOADABLE_MEDIA_TYPES = ['Document', 'Image']

/**
 * Regra do botão de download do conteúdo principal da aula: só aparece para
 * escolas com a feature `allow_course_content_download` ativa (ativação hoje é
 * por escola, via Heimdall). Vídeo, áudio e texto ficam de fora; planilha e Word
 * já têm download próprio no card do NotSupported.
 */
export function useDownloadContentAction(media?: IMedia | null) {
  const hasDownloadFeature = useHasFeature(ALLOW_COURSE_CONTENT_DOWNLOAD)
  const { download, isDownloading } = useContentDownload({
    fileExt: media?.fileExt,
  })

  const canDownload = useMemo(() => {
    if (!hasDownloadFeature) return false
    if (!media?.fileUrl) return false
    if (!DOWNLOADABLE_MEDIA_TYPES.includes(media.type ?? '')) return false

    return !isDownloadOnlyFileExt(media.fileExt)
  }, [hasDownloadFeature, media?.fileUrl, media?.type, media?.fileExt])

  const downloadContent = useCallback(() => {
    download(media?.fileUrl)
  }, [download, media?.fileUrl])

  return { canDownload, downloadContent, isDownloading }
}
